/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "1.14.0",
  "gitBuildTime": "2023-09-07T13:01:08.852Z",
  "gitBuildVersion": "1.14.0",
  "gitCommitId": "ce08e2b",
  "gitCommitIdFull": "ce08e2b3c7c4384cde8d00ed2db8d5f9cc767300",
  "gitCommitTime": "2023-09-07T12:59:46.000Z",
  "version": "1.14.0-2023-09-07T12:59:46.000Z-(ce08e2b)"
};
